import {
  Grid,
  Typography,
  Box,
  Button,
  Card,
  CardContent,
} from '@mui/material';
import { colors } from './Theme/WebTheme';
import cover1 from 'assets/img/cover_1.jpg';
import { Hail, LocalTaxi } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const Section = props => {
  const navigate = useNavigate();
  const cards = [
    {
      title: 'Soy pasajero',
      description: '',
      icon: <Hail style={{ fontSize: 50 }} />,
    },
    {
      title: 'Soy conductor',
      description: '',
      icon: <LocalTaxi style={{ fontSize: 50 }} />,
    },
  ];

  const handleNavigation = (path) => {
    navigate('/download');
  }

  return (
    <Box
      style={{
        backgroundImage: `url(${cover1})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <Grid
        container
        spacing={4}
        justifyContent="center"
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.7)',
          padding: '2rem',
          marginBottom: '1rem',
        }}
      >
        <Grid item xs={12}>
          <Typography
            variant="h4"
            align="center"
            gutterBottom
            fontWeight={'bold'}
          >
            ¡REGISTRATE!
          </Typography>
        </Grid>
        {cards.map((card, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card sx={{
              borderRadius: '15px',
            }}>
              <CardContent
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '1rem',
                }}
              >
                {card.icon}
                <Typography variant="body2" textAlign={'center'}>
                  {card.description}
                </Typography>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: colors.CAR_BOX_ODD,
                    borderRadius: '20px',
                    color: '#000',
                    '&:hover': {
                      backgroundColor: 'rgba(242, 147, 21, 0.6)',
                    }
                  }}
                  onClick={() => handleNavigation('/download')}
                >
                  <Typography fontWeight={'bold'}>{card.title}</Typography>
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Grid
        container
        spacing={4}
        justifyContent="center"
        paddingBlock={'6rem'}
        style={{
          backgroundColor: 'rgba(242, 147, 21, 1)',
          padding: '2rem',
          paddingBottom: '4rem',
        }}
      >
        <Grid item xs={12} md={4}>
          <Typography
            variant="h5"
            sx={{
              textAlign: 'center',
              color: '#fff',
              fontWeight: 'bold',
              textShadow: '2px 2px 4px rgba(0, 0, 0, 0.7)',
            }}
          >
            ECONOMÍA
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography
            variant="h5"
            sx={{
              textAlign: 'center',
              color: '#fff',
              fontWeight: 'bold',
              textShadow: '2px 2px 4px rgba(0, 0, 0, 0.7)',
            }}
          >
            COMODIDAD
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography
            variant="h5"
            sx={{
              textAlign: 'center',
              color: '#fff',
              fontWeight: 'bold',
              textShadow: '2px 2px 4px rgba(0, 0, 0, 0.7)',
            }}
          >
            SEGURIDAD
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Section;
